import React from 'react';
import Modal from '../modal';
// @ts-ignore
import { Router } from '../../configs/routes';

interface Props {
  onDismiss: () => void;
}

const KycUnderReviewModal: React.FC<Props> = ({ onDismiss }) => {
  return (
    <Modal
      title="KYC Under Review"
      maxWidth="500px"
      onDismiss={onDismiss}
      hideHeader={true}
    >
      <div className="lil-p-6 lil-text-center">
        <div className="lil-mb-6">
          <img
            src="https://assets.clear.in/clearsave/images/1766327077_frame2147223981.svg"
            alt="Info"
            className="lil-mx-auto lil-mb-4"
            width="100"
            height="100"
          />
        </div>
        <h3
          className="lil-mb-4 lil-font-bold lil-text-gray-900"
          style={{ fontSize: '20px' }}
        >
          KYC Under Review
        </h3>
        <p
          className="lil-mb-6 lil-text-gray-600 lil-leading-relaxed"
          style={{ fontSize: '14px' }}
        >
          Your KYC is under review and may take up to 2 business days. You can
          invest once KYC is approved.
        </p>
        <button
          className="lil-btn lil-btn-blue lil-w-full lil-mb-3"
          onClick={onDismiss}
        >
          Explore Black
        </button>
        <p className="lil-mb-6 lil-text-gray-500" style={{ fontSize: '14px' }}>
          For queries, contact{' '}
          <a
            href="mailto:invest@cleartax.in"
            className="lil-underline"
            style={{ color: '#155DFC' }}
          >
            invest@cleartax.in
          </a>
        </p>
      </div>
    </Modal>
  );
};

export default KycUnderReviewModal;



// WEBPACK FOOTER //
// ./components/kyc/KycUnderReviewModal.tsx